/**
 * global-icons.js
 * This is to whitelist icon included in the Webpack's bundle.
 * If not listed here, the icon won't appear.
 */

import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faArrowLeft,
  faArrowRight,
  faAward,
  faBell,
  faCalendar,
  faCaretDown,
  faChevronRight,
  faCheck,
  faCity,
  faClock,
  faCog,
  faColumns,
  faCommentAlt,
  faDoorOpen,
  faDownload,
  faEdit,
  faEnvelope,
  faHome,
  faInbox,
  faMap,
  faMapMarkerAlt,
  faUserCircle,
  faPhoneSquare,
  faSearch,
  faSignOutAlt,
  faTimes,
  faTimesCircle,
  faUser,
  faExclamationCircle,
  faPaperPlane,
  faBuilding,
  faUserFriends,
  faTrashAlt,
  faPen,
  faClipboardList,
  faClipboardCheck,
  faHistory,
  faBars,
  faToolbox,
  faTable,
  faFileAlt,
  faPlusCircle,
  faWarehouse,
  faSort,
  faSortDown,
  faSortUp,
  faEye
} from '@fortawesome/free-solid-svg-icons';

const importWhiteListedIcons = () => {
  library.add(
    faArrowLeft,
    faArrowRight,
    faAward,
    faBell,
    faCalendar,
    faCaretDown,
    faChevronRight,
    faCheck,
    faCity,
    faClock,
    faCog,
    faColumns,
    faCommentAlt,
    faDoorOpen,
    faDownload,
    faEdit,
    faEnvelope,
    faHome,
    faInbox,
    faMap,
    faMapMarkerAlt,
    faUserCircle,
    faPhoneSquare,
    faSearch,
    faSignOutAlt,
    faTimes,
    faTimesCircle,
    faUser,
    faExclamationCircle,
    faPaperPlane,
    faBuilding,
    faUserFriends,
    faTrashAlt,
    faPen,
    faClipboardList,
    faClipboardCheck,
    faHistory,
    faBars,
    faToolbox,
    faTable,
    faFileAlt,
    faPlusCircle,
    faWarehouse,
    faSort,
    faSortUp,
    faSortDown,
    faEye
  );
};

importWhiteListedIcons();
